var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_792_6482",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_792_6482",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAACgUlEQVR4nO2czU4UQRhFb7sA34ywMGqizzQ8hu6NEk1AX0h8BDQxl8V0iQk9zXRP1fdTfU8yYUXV+U6GGjIDBQghhBBCCCGEEEKIJ5A8J3lF8m58XJE89/Y6lhT+JM9IfuVTvpN86e33HCn8ZyTjyU6Qwv8IyTiyE6TwXyDpLztBCv8VkqFip/Dn/tX5ZoVk4YaOr+Zp/Ln/tedUXGJXiFzYWcjeVRAljY8Rrj8upvi1dP8XLYY6kgsA1xaxSZ4B+ATgVaUl/y79hjWhP6z4nkNcAPjMhsfIuPY16kUGgI8V15qG9c65/2lyZmdyPTRAzfOuUPXMzuCYfpDIbt0MFNGpCpEGi+TShAgDRnAwwXNQz71d8BjYY88QWA5uuVdILAJY7JGCliFart2qx9BqYeDf+wxfAFxWXPZ2/Fp7zbfDMPyuuKYtjZ59Ncl3XByCcWP3E7nAeLH7i1xgnNj9Ri7QP3b/kQuOsbcTueAQe3uRC4axtxu5YBBbkQsNY4eJ7Pl3HcKShs/mcM9qNwwiK7Zh5O3Gdoi8vdiOkbcTO0DkQr+xGSdyob/YjBe50E9sxo1cMImtD2cf18z54Sz15wbtsQhhsUdoLANY7hUKj8E99nTFc2DPvU2JMGgEh6ZEGjCSS1UiDhbR6SQiDxTZrbtBMjg+N0Caf/vN5DolX+O+DjNxtomd6r4O0uhHkfWPkVT3dfwA8GYYhvvWGw3D8AfAOwDfKi2Z5r6OWwCvLSIXxtjv8fg26ymkuK9Dl1ctkI1/nVkv/itkQ0QupPJfIBsqciGV/xGy/pIzpPKfkY0jOUMqf+5fzXckf46PHaNddD1Ddn8hhBBCCCGEEEIISx4AgjuniZaK5fIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.16a4d7f1b55a3b28305831dea0184c1c.svg";
export { ForwardRef as ReactComponent };